module.exports = __webpack_public_path__ + "1599b5408bb02e72e61b05de051ec99b.png";